import Alpine from 'alpinejs';
import 'swiper/css/bundle';
import { trans } from 'matice';
window.trans = trans;

import './cloak.js';
import './dates.js';
import './react.js';
import './cities.js';
import './professional-calendar.js';
import './cover-images.js';
import './featured-clinics.js';
import './ad-banners.js';
import './dashboard.js';
import './admin.js';
import './client-location.js';
import './inputs.js';
import './mood-checks.js';
import rescheduleAppointment from './reschedule-appointment.js';
import clinicsMap from './clinics-map.js';
import diagnosticTestsShop from './diagnostic-tests-shop.js';

window.Alpine = Alpine;
Alpine.data('rescheduleAppointment', rescheduleAppointment);
Alpine.data('clinicsMap', clinicsMap);
Alpine.data('diagnosticTestsShop', diagnosticTestsShop);
Alpine.start();
